var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEn = function SvgEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    className: "en_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231815",
    d: "M827.447 727.55h-80.352V572.546c0-32.799-1.717-54.027-5.131-63.655a44.55 44.55 0 0 0-16.758-22.435 47.7 47.7 0 0 0-27.895-8.02c-13.912 0-26.359 3.803-37.449 11.458-11.057 7.611-18.672 17.713-22.742 30.306-4.096 12.595-6.143 35.88-6.143 69.781V727.55h-80.351V423.818h74.64v44.62c26.508-34.334 59.854-51.468 100.079-51.468 17.759 0 33.939 3.187 48.614 9.557 14.687 6.405 25.813 14.53 33.32 24.45 7.542 9.92 12.81 21.16 15.733 33.755 2.935 12.595 4.436 30.603 4.436 54.071zm-629.767 0V308.28h310.876v70.91H282.32v92.98h210.49v70.66H282.32v114.062h234.255v70.657H197.724z"
  })));
};
export default SvgEn;